// src/admin/components/services/PrintServiceReceipt.jsx
import React, { useState, useEffect } from 'react';
import { getUserProfile } from '../../../models/userModel';
import api from '../../../services/api';
import UnifiedReceipt from '../shared/UnifiedReceipt';

const PrintServiceReceipt = ({ payment, onClose, autoPrint = false }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [orgSettings, setOrgSettings] = useState(null);

  // Fetch data on component mount
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { user } = await getUserProfile();
        setCurrentUser(user);
      } catch (error) {
        console.error('Failed to fetch user profile:', error);
      }
    };

    const fetchOrgSettings = async () => {
      try {
        const response = await api.get('/organization/settings');
        if (response.data && response.data.success) {
          setOrgSettings(response.data.organization);
        }
      } catch (error) {
        console.error('Failed to fetch organization settings:', error);
      }
    };

    fetchUserProfile();
    fetchOrgSettings();
  }, []);

  if (!payment || !orgSettings) {
    return (
      <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
        <div className="bg-white p-6 rounded-2xl shadow-xl flex items-center space-x-4">
          <div className="animate-spin h-6 w-6 border-4 border-teal-500 border-t-transparent rounded-full"></div>
          <span className="font-medium text-zinc-700">Loading receipt...</span>
        </div>
      </div>
    );
  }

  // Ensure type is 'service' for UnifiedReceipt
  return (
    <UnifiedReceipt
      data={payment}
      type="service"
      branding={{
        logoUrl: orgSettings.logoUrl,
        companyName: orgSettings.name,
        contactEmail: orgSettings.contactEmail,
        contactPhone: orgSettings.contactPhone,
        address: orgSettings.address
      }}
      onClose={onClose}
      autoPrint={autoPrint}
    />
  );
};

export default PrintServiceReceipt;
